import { render } from "./PublicFooter.vue?vue&type=template&id=927b38d8"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PublicFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "927b38d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('927b38d8', __exports__)) {
    api.reload('927b38d8', __exports__)
  }
  
  module.hot.accept("./PublicFooter.vue?vue&type=template&id=927b38d8", () => {
    api.rerender('927b38d8', render)
  })

}


export default __exports__